import { Dispatch } from 'redux';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IDepartmentItem } from 'src/entity/DepartmentEntity';
import { IStateDepartment, IStoreState } from 'src/entity/StateEntity';
import DepartmentAdminService from 'src/services/DepartmentAdminService';

export function reloadDepartments(): IStateDepartment {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.DEPARTMENT_STATUS_RELOAD,
    list: [],
  };
}

function requestDepartments(): IStateDepartment {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.DEPARTMENT_STATUS_REQUEST,
    list: [],
  };
}

function receiveDepartments(list: IDepartmentItem[], isSuccess: boolean): IStateDepartment {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.DEPARTMENT_STATUS_SUCCESS : ActionTypes.DEPARTMENT_STATUS_FAILURE,
    list,
  };
}

function fetchDepartments(storeState: IStoreState): any {
  return async (dispatch: Dispatch<IStateDepartment>): Promise<IStateDepartment> => {
    dispatch(requestDepartments());
    return DepartmentAdminService.fetchDepartments()
      .then((res: IDepartmentItem[]) => {
        // 临时处理 后台返回的顶层部门名称错误的问题
        const { userState } = storeState;
        const partnerName = userState.userInfo?.name;
        const topDepartment = res.find(item => !item.parent);
        if (topDepartment && partnerName) {
          topDepartment.name = partnerName;
        }
        return dispatch(receiveDepartments(res, true));
      }).catch(error => dispatch(receiveDepartments([], false)));
  };
}

function shouldFetchDepartments(storeState: IStoreState): boolean {
  const { departmentState } = storeState;
  return (departmentState.reload || departmentState.list.length === 0) && !departmentState.isFetching;
}

function createDepartmentState(data: IDepartmentItem, storeState: IStoreState): IStateDepartment  {
  const { departmentState } = storeState;
  const list = [...departmentState.list];
  list.push(data);
  return {
    reload: false,
    isFetching: false,
    type: ActionTypes.DEPARTMENT_MODIFY,
    list,
  }
}

function updateDepartmentState(data: IDepartmentItem, storeState: IStoreState): IStateDepartment  {
  const { departmentState } = storeState;
  const list = [...departmentState.list];
  const matchedIndex = list.findIndex(item => item.uuid === data.uuid);
  if (matchedIndex !== -1) {
    list.splice(matchedIndex, 1, data);
  }
  return {
    reload: false,
    isFetching: false,
    type: ActionTypes.DEPARTMENT_MODIFY,
    list,
  }
}

function deleteDepartmentState(uuid: string, storeState: IStoreState): IStateDepartment  {
  const { departmentState } = storeState;
  // 处理需要删除的部门以及其下子部门
  const childDepartments = DepartmentAdminService.getChildDepartments(uuid);
  const childIds = childDepartments.map(item => item.uuid);
  const deleteIds = [uuid, ...childIds];
  const rusult = departmentState.list.filter(item => {
    return deleteIds.findIndex(deleteId => deleteId === item.uuid) === -1;
  });
  return {
    reload: false,
    isFetching: false,
    type: ActionTypes.DEPARTMENT_MODIFY,
    list: rusult,
  }
}

export function fetchDepartmentsIfNeeded(forceReload = false): any {
  return (dispatch: Dispatch<IStateDepartment>, getState: any) => {
    if (shouldFetchDepartments(getState()) || forceReload) {
      return dispatch(fetchDepartments(getState()),);
    }
  };
}

export function createDepartment(data: Partial<IDepartmentItem>): any {
  return async (dispatch: Dispatch<IStateDepartment>, getState: any) => {
    return DepartmentAdminService.createDepartment(data)
      .then((res) => {
        if (res) {
          dispatch(createDepartmentState(res, getState()));
        }
        return res;
      }
    )
  }
}

export function updateDepartment(data: Partial<IDepartmentItem>): any {
  return async (dispatch: Dispatch<IStateDepartment>, getState: any) => {
    return DepartmentAdminService.updateDepartment(data, data.uuid as string)
      .then((res) => {
        if (res) {
          dispatch(updateDepartmentState(res, getState()))
        }
        return res;
      }
    )
  }
}

export function deleteDepartment(uuid: string): any {
  return async (dispatch: Dispatch<IStateDepartment>, getState: any) => {
    return DepartmentAdminService.deleteDepartment(uuid)
      .then((res) => {
        if (res) {
          dispatch(deleteDepartmentState(uuid, getState()))
        }
        return res;
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/departmentCreator.ts